var ReservationSegmentCardConstants = {
  // ACTIVATE_LOCKS: "activateLocks",
  // DEACTIVATE_LOCKS: "deactivateLocks",
  // RESET_LOCKS: "resetLocks",
  REACTIVATE_LOCKS: "reactivateLocks",
  CHANGE_EVENT: "changeEvent",
  INIT: "init",
  REFRESH: "refresh",
  SAVE: "save",
  SET_ACTIVE_TAB: "setActiveTab",
  SET_SUBMIT_BUTTON: "setSubmitButton",
  EDIT_RESERVATION_SEGMENT: "editReservationSegment",
  CHANGE_DATES: "changeDates",
  CHANGE_ROOM: "changeRoom",
  CHANGE_ROOM_TYPE: "changeRoomType",
  CHANGE_CUSTOMERS: "changeCustomers",
  CHANGE_STATUS: "changeStatus",
  CHANGE_INCIDENTAL_DEPOSIT_CARD: "changeIncidentalDepositCard",
  CHANGE_PAYMENT_CARD: "changePaymentCard",
  CHANGE_PAYMENT_CUSTOMER: "changePaymentCustomer",
  CHANGE_PAYMENT_AMOUNT: "changePaymentAmount",
  CHANGE_PAYMENT_EVENT: "changePaymentEvent",
  APPLY_PROMOTION: "applyPromotion",
  CHANGE_GUESTS: "changeGuests",
  REMOVE_PROMOTION: "removePromotion",
  CHANGE_NOTES: "changeNotes",
  APPLY_DISCOUNT: "applyDiscount",
  CHANGE_RATE: "changeRate",
  CHECK_IN: "checkIn",
  CHANGE_PAYMENT_TYPE: "changePaymentType",
  UPDATE_NOTE_COUNT: "updateNoteCount",
  UPDATE_SERVICE_REQUEST_COUNT: "updateServiceRequestCount",
  UPDATE_CLOSED_COUNT: "updateClosedCount",
};

export default ReservationSegmentCardConstants;
